import { ConfigureViewPresetSize } from '../../shared/configure-view-preset-size';
import * as _ from 'lodash';
// @dynamic
var ViewPresetSize = /** @class */ (function () {
    function ViewPresetSize() {
    }
    ViewPresetSize.init = function () {
        this._presetMobileSizes = [];
        this._presetWebSizes = [];
        this._presetWebSizes.push(new ConfigureViewPresetSize(1, '3840*2160(4K-16:9)', 3840, 2160));
        this._presetWebSizes.push(new ConfigureViewPresetSize(2, '2560*1440(2K-16:9)', 2560, 1440));
        this._presetWebSizes.push(new ConfigureViewPresetSize(3, '1920*1080(FHD-16:9)', 1920, 1080));
        this._presetWebSizes.push(new ConfigureViewPresetSize(4, '1366*768(HD-16:9)', 1366, 768));
        this._presetWebSizes.push(new ConfigureViewPresetSize(5, '1280*720(WXGA-16:9)', 1280, 720));
        this._presetWebSizes.push(new ConfigureViewPresetSize(6, '1024*768(XGA-4:3)', 1024, 768));
        this._presetWebSizes.push(new ConfigureViewPresetSize(7, '800*480(5:3)', 800, 480));
        this._presetWebSizes.push(new ConfigureViewPresetSize(0, 'Custom'));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(1, '1440*2880(2K-9:18)', 1440, 2880));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(2, '1242*2298(iPhone6,7,8 Plus)', 1242, 2298));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(3, '1080*1920(Android 1080P)', 1080, 1920));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(4, '750*1334(iPhone6,7,8)', 750, 1334));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(5, '720*1280(9:16)', 720, 1280));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(6, '480*800(3:5)', 480, 800));
        this._presetMobileSizes.push(new ConfigureViewPresetSize(0, 'Custom'));
    };
    Object.defineProperty(ViewPresetSize, "presetWebSizes", {
        get: function () {
            if (this._presetWebSizes.length === 0) {
                this.init();
            }
            return _.cloneDeep(this._presetWebSizes);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewPresetSize, "presetMobileSizes", {
        get: function () {
            if (this._presetMobileSizes.length === 0) {
                this.init();
            }
            return _.cloneDeep(this._presetMobileSizes);
        },
        enumerable: true,
        configurable: true
    });
    ViewPresetSize._presetWebSizes = [];
    ViewPresetSize._presetMobileSizes = [];
    return ViewPresetSize;
}());
export { ViewPresetSize };
